interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

const SupportIcon = ({ width = '20', height = '20', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.167 15.3588H10.8337L7.12532 17.8254C6.57532 18.1921 5.83366 17.8004 5.83366 17.1338V15.3588C3.33366 15.3588 1.66699 13.6921 1.66699 11.1921V6.19206C1.66699 3.69206 3.33366 2.02539 5.83366 2.02539H14.167C16.667 2.02539 18.3337 3.69206 18.3337 6.19206V11.1921C18.3337 13.6921 16.667 15.3588 14.167 15.3588Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                />
                <path
                    d="M9.99952 9.4668V9.29183C9.99952 8.72516 10.3495 8.42515 10.6995 8.18348C11.0412 7.95015 11.3828 7.65016 11.3828 7.10016C11.3828 6.33349 10.7662 5.7168 9.99952 5.7168C9.23286 5.7168 8.61621 6.33349 8.61621 7.10016"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.99592 11.4587H10.0034"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};

export default SupportIcon;
